export default __webpack_public_path__ + "static/DMSans-Bold-e9862f0412795e18b890aadf60e6e470.woff";